<template>
    <div class="rp-loading-dots">
        <div
            v-for="(value, index) in dotsLength"
            :key="'rp-loading-dots'+index"
            class="rp-loading-dots--dot"
            :style="stylesForLoader"
        ></div>
    </div>
</template>
<script>
export default {
    props: {

        dotColor: {
            type: String,
            required: false,
        },

        dotCount: {
            type: Number,
            default: 3
        }

    },

    computed: {
        dotsLength() {
            return new Array(this.dotCount); 
        },

        stylesForLoader() {
            if(this.dotColor) {
                return { backgroundColor: this.dotColor }
            }
            return {}
        }
    }
}
</script>
<style lang="scss" scoped>
@keyframes dot-keyframes {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }

    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }

    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}
.rp-loading-dots {
    text-align: center;
    width: 100%;

    &--dot {
        animation: dot-keyframes 1.5s infinite ease-in-out;
        background-color: var(--theme-color);
        border-radius: 8px;
        display: inline-block;
        height: 8px;
        width: 8px;
        margin-right: 3px;

        &:nth-child(2) {
            animation-delay: .5s;
        }
        
        &:nth-child(3) {
            animation-delay: 1s;
        }
    }
}
</style>